import $ from 'jquery';
import Vue from 'vue';
import { i18n } from '@/plugins/i18n';
import en from "jquery-ui/ui/i18n/datepicker-en-GB";
import fr from "jquery-ui/ui/i18n/datepicker-fr";


/**
 * Try to have the base language without other langtag as preferred language, if there is any
 * Ex: 'fr-CH' -> 'fr'
 * @param {String} language following BCP 47 guideline (https://tools.ietf.org/html/bcp47)
 * @return {String} Base language following BCP 47 standard without other langtag attached to it
 */
export function getBaseLanguageOf(language) {
  if (language.indexOf('-') !== -1) {
    [language] = language.split('-');
  }
  if (language.indexOf('_') !== -1) {
    [language] = language.split('_');
  }
  return language;
}

/**
 * Collect list of user's preferred languages (First is best)
 * @return {String[]} List of languages, following the BFC 47 standard
 */
export function getBrowserLanguages() {
  if (!window.navigator) return [];

  let languages;
  if (window.navigator.languages) {
    ({ languages } = window.navigator);
  } else {
    // Support for old browser and IE
    const language = window.navigator.language
      || window.navigator.userLanguage
      || window.navigator.browserLanguage;
    if (!language) {
      return [];
    }
    languages = [language];
  }
  // Support for Safari mobile ; navigator.languages doesn't containt base languages
  const addLang = [];
  languages.forEach((lang) => {
    const base = getBaseLanguageOf(lang);
    if (lang !== base && !languages.find(l => l !== base)) {
      addLang.push(base);
    }
  });
  return languages.concat(addLang);
}

/**
 * Set all language-related defaults
 * @param {String} lang - language from state
 */
export function setLanguageRelatedDefaults(lang) {
  i18n.locale = lang;
  if (Vue.moment) {
    Vue.moment.locale(lang);
  }
  // jQuery UI defaults
  $.datepicker.setDefaults({
    firstDay: i18n.t('datePickerFirstDay'),
    ...$.datepicker.regional[lang],
  });
}

export default {
  getBaseLanguageOf,
  getBrowserLanguages,
  setLanguageRelatedDefaults,
};
